export default __webpack_public_path__ + "static/media/client3.0aa2cbde.png";